import React, { useState, useEffect } from 'react';
import { Typography, Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import ClasseCard from '../../components/Classes/ClasseCard';
import { listarClasses } from '../../services/classeService';

const ListaClassesPage = () => {
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const data = await listarClasses();
        setClasses(data);
      } catch (error) {
        console.error('Erro ao buscar classes:', error);
        // TODO: Adicionar tratamento de erro e feedback ao usuário
      }
    };

    fetchClasses();
  }, []);

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Classes
      </Typography>
      <Button
        component={Link}
        to="/classes/criar"
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
      >
        Adicionar Nova Classe
      </Button>
      <Grid container spacing={3}>
        {classes.map((classe) => (
          <Grid item key={classe.id} xs={12} sm={6} md={4}>
            <ClasseCard classe={classe} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ListaClassesPage;